import { PostType } from "../types/services/IPost";
import { deletePost } from "./fetch";

export async function deletePostWithChildCleanup(
  charityId: string,
  postType: PostType,
  postId: string,
  adminUrl: string,
  token: string
): Promise<void> {
  await deletePost(charityId, postType, postId, adminUrl, token);
}
